<template>
  <div>
    <el-table
        v-loading="loading"
        :data="tableData"
        height="85vh"
        style="width: 100%">
      <el-table-column prop="customerName" align="center" label="客户名称"/>
      <el-table-column prop="totalMoney" align="center" label="统计金额"/>
    </el-table>
  </div>
</template>

<script>

  export default {
    name: "CustomerAmountSummaryList",
    components: {},
    data() {
      return {
        loading: false,
        tableData: [],
        filter: {
          customerName: "",
          totalMoney: "",
        },
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      getList() {
        this.loading = true;
        this.$http.get("basic","sAPShipmentInvoices/getCustomerPriceStatistic601").then(res => {
          console.log(res);
          this.loading = false;
          this.tableData = res;
        }).catch(() => {
          this.loading = false;
          this.$message.error("获取失败");
        });
      },
    },
  };
</script>

<style scoped>

</style>
